export default __webpack_public_path__ + "static/media/RTR200FI_Frente.af4bcd90.webp";